import React  from 'react';

import useTextCorrection from "../../hooks/useTextCorrection";

import {
  TableBody
} from "./index.style";

interface DetailsTable {
  headings: {},
  tableData: object,
}

// PORTAL-127. "Trade Type" and "Status" are the only DetailsTable fields Pronto returns in
// inconsistent casing for a customer-facing audience - everything else in this generic table
// (notes, names, references, serials) is free text or an identifier that should not be reshaped.
const TITLE_CASE_FIELDS = ['Action', 'Status'];

// PORTAL-128. These three headings all describe the same billed-job invoice, and Pronto
// leaves all three empty together on a contract unit that has never been invoiced - so
// "Invoice Amount" alone being hidden left "Invoice Number: Not defined" and "Invoice to
// date: Invalid date" sitting right below it on the exact same unbilled asset. Gating all
// three on InvoiceNo keeps them consistent instead of fixing one and leaving the other two
// looking just as broken.
const UNBILLED_INVOICE_FIELDS = ['InvoiceAmount', 'InvoiceNo', 'InvoicedToDate'];

const DetailsTable: React.FC<DetailsTable> = ({headings, tableData}) => {
  const {filterEmpty, correctDateFormat, isEmptyValue, titleCase} = useTextCorrection();

  return (
    <TableBody>
      <tbody>
      {Object.keys(headings).map((header: string) => {
        let component = tableData[headings[header]];
        if(header.includes("csvonly")) return;
        if(UNBILLED_INVOICE_FIELDS.includes(headings[header]) && !tableData['InvoiceNo']) return;
        if(isEmptyValue(component)) return;
        if(TITLE_CASE_FIELDS.includes(headings[header])) component = titleCase(component);
        if(header.toLowerCase().includes('amount')) component = "$" + component;
        component = correctDateFormat(component,header);
        return (
          <tr>
            <th>{header}</th>
            {filterEmpty(component)}
          </tr>
        );
      })}
      </tbody>
    </TableBody>
  );

};

export default DetailsTable;